import { SchemaService } from "@/shared/services/SchemaService";
import { RuleSchema } from "../models/RuleSchema";
import { DataCleaningService } from "./DataCleaningService";


export class DataCleaningSchemaService extends SchemaService<RuleSchema> {

    static readonly injectableKey = 'DataCleaningSchemaService';

    get injectableKey() {
        return (this.constructor as typeof DataCleaningSchemaService).injectableKey;
    }

    public cdnContentPath: string = "data_cleaning/rule_schemas";

    public getInternalSchemas(): Array<RuleSchema> {

        const internalRuleSchemas = [
            {
                "type": `${DataCleaningService.CUSTOM_RULE_TYPE}`,
                "display_name": "Unknown Rule",
                "description": "Add unknown rule",
                "category": "Custom",
                "is_visible": true,
                "fields": [
                    {
                        "name": "value",
                        "display_name": "Json",
                        "field_type": "json",
                        "required": true,
                        "description": "Json Value"
                    }
                ],
                "examples": [
                    {
                        "type": "json"
                    }
                ]
            }
        ] as Array<RuleSchema>;

        return internalRuleSchemas;

    }

}